const __request = require(`@/lib/data-service/default/__request/`);
/**
 * 供应商文件预览
 */
export default function (val) {
    var pParameter = {}
    pParameter.method = "POST"
    pParameter.urlSuffix = "/web/esIgn/esIgnSignerController/supplierFilePreview"
    pParameter.data = val
    return new Promise(function (resolve, reject) {
        resolve(__request(pParameter))
    })
}
